export default __webpack_public_path__ + "current-logo.2a09f2b6.png";